/* eslint-disable prettier/prettier */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import {
  SliderStyled,
  Wrapper,
  Buffered,
  Connect,
  Content,
  ContentWrap,
  Handler,
  HoverThumbnail,
  SeekHover,
  VolumeButton,
  Thumb,
  Thumbnail,
  TimeThumbnail,
  Track,
  TrackContent,
  StyledButton,
  AdTimeLabel,
} from "./styles/SliderStyled";

class Slider extends PureComponent {
  static SLIDE_PHASE = {
    START: "start",
    UPDATE: "update",
    END: "end",
  };

  constructor(props) {
    super(props);
    this.state = {
      trackWidth: 0,
      seeking: false,
      slidedTime: props.currentTime,
      hoverPosition: 0,
    };
    this.lastPhase = null;
    this.seekHoverPosition = 0;
    this.trackHovered = false;
    this.lastTime = 0;
    this.throttleFunc = null;
    if (props.throttlingTime) {
      this.throttleFunc = _.throttle((time, phase, mobile) => {
        if (!mobile) {
          props.onChange(time, phase);
        }
      }, this.props.throttlingTime);
    }
    // this.throttledSeek = null;
    this.seeking = null;
    this.updatedPosition = true;
    this.playerPause = false;
    this.setSkipAdToFalse = false;
    // this.currentTimeTargetSeekTimeoutId = '';
  }

  componentDidMount() {
    this.setTrackWidthState();
    window.addEventListener("resize", this.setTrackWidthState);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.currentTime !== this.props.currentTime) {
      this.updatedPosition = true;
    }
  }

  componentDidUpdate(prevProps) {
    const { getSeeking, type, paused, setSkipAdProperty } = this.props;
    const { seeking } = this.state;

    if (this.setSkipAdToFalse && !paused && paused !== prevProps.paused) {
      this.setSkipAdToFalse = false;
      window.setTimeout(() => {
        setSkipAdProperty(false);
      }, 500);
    }

    this.setTrackWidthState();
    getSeeking(seeking, type || "seekbar");
  }

  componentWillUnmount() {
    // try to remove all event listeners
    // just for safety...
    window.removeEventListener("resize", this.setTrackWidthState);
    window.removeEventListener("mousemove", this.onWindowMouseMove);
    window.removeEventListener("mouseup", this.onWindowMouseUp);
    window.removeEventListener("touchmove", this.onWindowTouchMove);
    window.removeEventListener("touchend", this.onWindowTouchEnd);
  }

  onTrackMouseMove = (event) => {
    this.toggleThumbnail(true, event); // shows thumbnail while hovering track
  };

  onTrackMouseLeave = (event) => {
    this.toggleThumbnail(false, event); // hide thumbnail when cursor leaves track
  };

  onTrackMouseDown = (event) => {
    // change track position, inits mouse events to handle seeking while mouseDown
    if (event.button === 0) {
      this.props.handleSeeking(true);
      this.setSeeking(true);
      this.changeCurrentTimePosition(
        event.pageX,
        Slider.SLIDE_PHASE.START,
        event
      );

      window.addEventListener("mousemove", this.onWindowMouseMove);
      window.addEventListener("mouseup", this.onWindowMouseUp);
    }
  };

  onWindowMouseMove = (event) => {
    // update time and thumbnail position while seeking
    const { seeking } = this.state;
    if (seeking) {
      this.changeCurrentTimePosition(
        event.pageX,
        Slider.SLIDE_PHASE.UPDATE,
        event
      );
      this.toggleThumbnail(true, event);
    }
  };

  onWindowMouseUp = (event) => {
    // hide thumb, set final time position after we stopped seeking
    window.removeEventListener("mousemove", this.onWindowMouseMove);
    window.removeEventListener("mouseup", this.onWindowMouseUp);

    this.props.handleSeeking(false);
    this.setSeeking(false);
    this.changeCurrentTimePosition(event.pageX, Slider.SLIDE_PHASE.END, event);
    if (!this.trackHovered) {
      this.toggleThumbnail(false, event);
    }
  };

  onTrackTouchStart = (event) => {
    // change track position, inits touch events to handle seeking after touchStart
    this.props.handleSeeking(true);
    this.setSeeking(true);
    this.updatedPosition = false;
    this.setState({
      slidedTime: this.props.currentTime,
    });
    if (event.changedTouches) {
      this.changeCurrentTimePosition(
        event.changedTouches[0].pageX,
        Slider.SLIDE_PHASE.START,
        event
      );
      this.onSliderSeekPause();
    }

    const { isMobile, type } = this.props;
    if (isMobile && type !== "volume") {
      window.addEventListener("touchmove", this.onWindowTouchMove);
      window.addEventListener("touchend", this.onWindowTouchEnd);
    }
  };

  onWindowTouchMove = (event) => {
    // update time and thumbnail position while seeking on touchscreen
    const { seeking } = this.state;

    if (seeking && event.changedTouches) {
      let pageX = 0;
      for (let i = 0; i < event.changedTouches.length; ++i) {
        pageX = event.changedTouches[i].pageX;
      }
      pageX = pageX < 0 ? 0 : pageX;
      this.changeCurrentTimePosition(pageX, Slider.SLIDE_PHASE.UPDATE, event);
      this.toggleThumbnail(true, event);
    }
  };

  onWindowTouchEnd = (event) => {
    // hide thumb, set final time position after we stopped seeking on touchscreen
    this.props.handleSeeking(false);
    this.setSeeking(false);
    if (event.changedTouches) {
      this.changeCurrentTimePosition(
        event.changedTouches[0].pageX,
        Slider.SLIDE_PHASE.END,
        event
      );
    }
    if (!this.trackHovered) {
      this.toggleThumbnail(false, event);
    }
    window.removeEventListener("touchmove", this.onWindowTouchMove);
    window.removeEventListener("touchend", this.onWindowTouchEnd);
  };

  onContentWrapperTransitionEnd = (event) => {
    // handle width update for volume slider when it has been opened
    if (event.propertyName === "width" && this.props.type === "volume") {
      if (this.track && this.track.offsetWidth > 0) {
        // update width only when it starts opening
        this.setTrackWidthState();
      }
    }
  };

  onSliderSeekPause = () => {
    // resolve case, when the user seeks while video is on pause
    const { paused, setSkipAdProperty, pause } = this.props;

    this.playerPause = paused;
    if (!paused) {
      setSkipAdProperty(true);
      pause();
    }
  };

  onSliderSeekPlay = () => {
    // resolve case, when the user seeks while video is playing
    const { play } = this.props;
    if (!this.playerPause) {
      play();
      this.setSkipAdToFalse = true;
    }
  };

  setTrackWidthState = () => {
    // sets track width state
    if (this.track) {
      this.setState({
        trackWidth: this.track.offsetWidth,
      });
    }
  };

  setSeeking = (state) => {
    // sets seeking state
    this.seekHoverPosition = !state ? 0 : this.seekHoverPosition;
    this.setState({
      seeking: state,
      hoverPosition: this.seekHoverPosition,
    });
  };

  getPositionStyle = () => {
    // set position for track indicator (on mobile devices)
    const { max, currentTime, isMobile } = this.props;
    const { trackWidth, slidedTime } = this.state;
    let time = 0;
    if (isMobile) {
      time =
        !this.updatedPosition || this.state.seeking ? slidedTime : currentTime;
    } else {
      time =
        this.lastPhase === Slider.SLIDE_PHASE.UPDATE && this.throttleFunc
          ? slidedTime
          : currentTime;
    }

    const position = trackWidth / (max / time);

    return {
      transform: `translateX(${-trackWidth + position}px)`,
    };
  };

  getThumbHandlerPosition = () => {
    // sets position for thumbHandler
    const { max, currentTime } = this.props;
    const { trackWidth } = this.state;
    const position = trackWidth / (max / currentTime);

    return {
      transform: `translateX(${position}px)`,
    };
  };

  getSeekHoverPosition = () => {
    // sets styles for track hover
    const { trackWidth, hoverPosition } = this.state;

    return {
      transform: `scaleX(${hoverPosition / trackWidth})`,
    };
  };

  getThumbnailPosition = () => {
    // gets position for thumbnail, resolve cases where thumb is at the beginning or in the end of track
    const { trackWidth } = this.state;
    const { thumbnails, isMobile } = this.props;
    const thumbWidth =
      this.thumbnail && this.thumbnail.offsetWidth > 0
        ? this.thumbnail.offsetWidth
        : parseInt(thumbnails.width, 10);
    const multiplier = isMobile ? -1.5 : -1;
    let position = 0;
    if (thumbWidth > 0) {
      position = this.seekHoverPosition - thumbWidth / 2;
      if (position < 0) {
        // left
        position = 0;
      }
      if (position + thumbWidth > trackWidth) {
        // right
        position = trackWidth - thumbWidth;
      }
    }
    return {
      transform: `translateX(${position}px)`,
      top: Math.round((thumbnails.height || 0) * multiplier),
    };
  };

  getTimeValue = () => {
    // get current time position
    const { trackWidth } = this.state;
    const { max } = this.props;
    const percent = this.seekHoverPosition * 100 / trackWidth;
    return Math.round(percent * (max / 100));
  };

  getTime = () => {
    // parse duration into hours:minutes:seconds format
    const { max, offset, secondsPrefix, minutesPrefix } = this.props;
    const time = this.getTimeValue();
    if (max + offset < 60) {
      return secondsPrefix + (time + offset);
    }
    if (max + offset < 3600) {
      const times = this.secondsToTime(time);
      return `${minutesPrefix + times.mm}:${times.ss}`;
    }
    const times = this.secondsToTime(time);
    return `${times.hh}:${times.mm}:${times.ss}`;
  };

  toggleThumbnail = (state, event) => {
    // set showThumbnail state true or false (show or hide thumbnail)
    const { onChangeHoverTime } = this.props;
    if (state) {
      this.handleTrackHover(false, event);
      onChangeHoverTime(this.getTimeValue());
    } else {
      this.handleTrackHover(true, event);
    }
  };

  handleTrackHover = (clear, event) => {
    // handles track hover and run methods related to hover position and thumb position
    let position;
    let pageX = 0;
    if (event.pageX !== undefined) {
      pageX = event.pageX;
    } else if (event.changedTouches) {
      pageX = event.changedTouches[0].pageX;
    }
    position = pageX - this.track.getBoundingClientRect().left;

    if (clear) {
      position = 0;
    }

    this.seekHoverPosition = position;
    this.trackHovered = clear;
    this.setState({
      hoverPosition: position,
    });
  };

  secondsToTime = (seconds) => {
    // parse seconds to hours:minutes:seconds
    const hours = Math.floor(seconds / 3600);
    const divirsForMinutes = seconds % 3600;
    const minutes = Math.floor(divirsForMinutes / 60);
    const sec = Math.ceil(divirsForMinutes % 60);
    return {
      hh: hours.toString(),
      mm: minutes < 10 ? `0${minutes}` : minutes.toString(),
      ss: sec < 10 ? `0${sec}` : sec.toString(),
    };
  };

  thumbnailStyle = (thumbnails) => {
    // creating styles for thumbnail
    const multiplier = this.props.isMobile ? 1.5 : 1;

    return (
      <Thumbnail thumbnails={thumbnails} multiplier={multiplier}>
        <TimeThumbnail>{this.getTime()}</TimeThumbnail>
      </Thumbnail>
    );
  };

  // increaseIncrement = () => { // setting rewind increment
  //   clearTimeout(this.seeking);
  //   const { increment } = this.state;
  //   if (increment < 95) {
  //     this.setState({
  //       increment: increment + 5,
  //     });
  //   }
  //   this.seeking = setTimeout(() => {
  //     this.setState({
  //       increment: 0,
  //     });
  //   }, 500);
  // };

  // changeSeekerPosition = (increment) => { // change position while seeking with time delays to optimize loading
  //   const { onChange, currentTime, max } = this.props;
  //
  //   if (this.currentTimeTargetSeekTimeoutId) {
  //     clearTimeout(this.currentTimeTargetSeekTimeoutId);
  //   }
  //
  //   this.currentTimeTargetSeekTimeoutId = setTimeout(() => {
  //     this.currentTimeTargetSeekTimeoutId = null;
  //   }, 250); // if user clamped button prev/next
  //
  //   if (!this.throttledSeek) {
  //     this.throttledSeek = _.throttle((time) => onChange(time), 100);
  //   }
  //
  //   if (currentTime + increment < max - 10) {
  //     if (currentTime + increment > 0) {
  //       this.throttledSeek(currentTime + increment); // add new time
  //     } else {
  //       this.throttledSeek(1);
  //     }
  //   } else if (currentTime <= max - 15) {
  //     this.throttledSeek(max - 10);
  //   }
  // };

  changeCurrentTimePosition = (pageX, phase, event) => {
    // change position when the user is seeking
    const { trackWidth } = this.state;
    const { max, onChange, threshold, isMobile } = this.props;
    let position = pageX - this.track.getBoundingClientRect().left;
    let canUpdate = false;
    position = position < 0 ? 0 : position;
    position = position > trackWidth ? trackWidth : position;
    this.seekHoverPosition = position;

    const percent = position * 100 / trackWidth || 0;
    const time = Math.round(percent * (max / 100));

    if (isMobile) {
      canUpdate = phase === Slider.SLIDE_PHASE.END;
    } else {
      canUpdate = Math.abs(time - this.lastTime) > threshold;
    }

    this.lastPhase = phase;
    if (
      (this.throttleFunc || isMobile) &&
      phase === Slider.SLIDE_PHASE.UPDATE
    ) {
      this.updatedPosition = false;
      this.setState({
        slidedTime: time,
      });
      if (canUpdate && !isMobile) {
        this.throttleFunc(time, phase, isMobile);
        this.lastTime = time;
      }
    } else if (canUpdate) {
      onChange(time, phase);
      this.lastTime = time;

      if (isMobile) {
        this.toggleThumbnail(false, event);
        this.onSliderSeekPlay();
      }
    }
  };

  assignTrackRef = (ref) => {
    this.track = ref;
  };

  assignThumbnailRef = (ref) => {
    this.thumbnail = ref;
  };

  isThumbActive = () => {
    // set whether thumb is visible or not
    const { seeking } = this.state;

    return this.seekHoverPosition > 0 || seeking;
  };

  drawThumbnail = () => {
    const { thumbnails } = this.props;

    return (
      <HoverThumbnail
        activeThumb={this.isThumbActive()}
        style={this.getThumbnailPosition()}
        ref={this.assignThumbnailRef}
      >
        {this.thumbnailStyle(thumbnails)}
      </HoverThumbnail>
    );
  };

  renderSlider = () => {
    const { seeking } = this.state;
    const {
      loadedFraction,
      // thumbnails,
      thumbHandler,
      useBuffering,
      useHoverFill,
      isMobile,
      type,
      connectColor,
      adTimeLabels,
      max,
    } = this.props;

    // const { showThumbnail } = this.state;

    const desktopEvents = !isMobile
      ? {
          onMouseMove: this.onTrackMouseMove,
          onMouseLeave: this.onTrackMouseLeave,
          onMouseDown: this.onTrackMouseDown,
        }
      : {
          onTouchStart: this.onTrackTouchStart,
          onTouchMove: this.onTrackMouseMove,
        };
    return (
      <ContentWrap
        type={type}
        seeking={type === "volume" && seeking}
        onTransitionEnd={this.onContentWrapperTransitionEnd}
      >
        <Track>
          <TrackContent
            {...desktopEvents}
            isMobile={isMobile}
            type={type}
            ref={this.assignTrackRef}
          >
            <Wrapper
              activeThumb={this.isThumbActive()}
              isMobile={isMobile}
              type={type}
            >
              {useBuffering && (
                <Buffered
                  style={{
                    transform: `scaleX(${loadedFraction})`,
                  }}
                />
              )}
              <Connect
                isMobile={isMobile}
                connectColor={connectColor}
                style={this.getPositionStyle()}
              >
                {/* {isMobile && <TrackThumb />} */}
              </Connect>
              {!isMobile &&
                useHoverFill && (
                  <SeekHover style={this.getSeekHoverPosition()} />
                )}

              {Boolean(adTimeLabels.length) &&
                adTimeLabels.map(({ time }) => (
                  <AdTimeLabel key={time} point={time * 100 / max} />
                ))}
            </Wrapper>
          </TrackContent>

          {this.drawThumbnail()}

          {thumbHandler ? (
            <Thumb style={this.getThumbHandlerPosition()}>
              <Handler activeThumb={this.isThumbActive()} />
            </Thumb>
          ) : null}
        </Track>
      </ContentWrap>
    );
  };

  renderSliderByType = (type) => {
    const {
      icon,
      onVolumeIconClick,
      isMobile,
      volumeIconColor,
      volumeHoverColor,
    } = this.props;

    if (type === "volume") {
      return (
        <Content>
          <VolumeButton>
            <StyledButton
              onClick={onVolumeIconClick}
              data-role="volume"
              iconSize={isMobile ? 17 : 24}
              icon={icon}
              iconColor={volumeIconColor}
              hoverColor={volumeHoverColor}
              isMobile={isMobile}
            />
          </VolumeButton>
          {!isMobile ? this.renderSlider() : ""}
        </Content>
      );
    }
    return <Content>{this.renderSlider()}</Content>;
  };

  render() {
    const { type } = this.props;

    return <SliderStyled>{this.renderSliderByType(type)}</SliderStyled>;
  }
}

Slider.propTypes = {
  onChange: PropTypes.func.isRequired,
  offset: PropTypes.number,
  max: PropTypes.number.isRequired,
  currentTime: PropTypes.number.isRequired,
  minutesPrefix: PropTypes.string,
  secondsPrefix: PropTypes.string,
  loadedFraction: PropTypes.number,
  type: PropTypes.string,
  useBuffering: PropTypes.bool,
  useHoverFill: PropTypes.bool,
  drawThumbnail: PropTypes.bool,
  thumbHandler: PropTypes.bool,
  thumbnails: PropTypes.object,
  onChangeHoverTime: PropTypes.func,
  icon: PropTypes.string,
  onVolumeIconClick: PropTypes.func,
  pause: PropTypes.func,
  play: PropTypes.func,
  paused: PropTypes.bool,
  getSeeking: PropTypes.func,
  isMobile: PropTypes.bool,
  throttlingTime: PropTypes.number,
  threshold: PropTypes.number,
  setSkipAdProperty: PropTypes.func,
  handleSeeking: PropTypes.func,
  connectColor: PropTypes.string,
  adTimeLabels: PropTypes.array,
};

Slider.defaultProps = {
  offset: 0,
  minutesPrefix: "",
  secondsPrefix: "",
  loadedFraction: 0,
  useBuffering: false,
  useHoverFill: true,
  drawThumbnail: true,
  thumbnails: {},
  thumbHandler: false,
  type: null,
  onChangeHoverTime: Function.prototype,
  icon: "",
  onVolumeIconClick: Function.prototype,
  play: Function.prototype,
  pause: Function.prototype,
  paused: null,
  getSeeking: Function.prototype,
  isMobile: false,
  throttlingTime: undefined,
  threshold: 0,
  setSkipAdProperty: Function.prototype,
  handleSeeking: Function.prototype,
  connectColor: "",
  adTimeLabels: [],
};

export default Slider;
